import { render } from "./SideMenu.vue?vue&type=template&id=b3e54b24"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"

import "./SideMenu.vue?vue&type=style&index=0&id=b3e54b24&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__